import React, { useMemo } from "react";
import { getColor } from "../../themes";
import { TabData } from "./Tab";
import { GraphTableInfoToggle } from "./TogglePanel";
import { CategorySetDisplay } from "./types";
import { useCategoryMetaContext } from "../Context";
import { event as visualToggleEvent } from "../GA/ProviderInfo/VisualToggle";
import _ from "lodash";
import { useLocation } from "react-router-dom";

export const CategorySetToggleDisplay: React.FC<CategorySetDisplay> = ({ categories }) => {
    const { CategoryContent } = require("./CategoryContent");
    const { tIdToCategory } = useCategoryMetaContext();
    const { pathname } = useLocation();
    const categoriesTabActivated = useMemo(() => {
        return categories.map(category => {
            return (tab: TabData) => {
                const categoryParent = tIdToCategory?.[category?.parentId];
                const categorySuperParent = tIdToCategory?.[categoryParent?.parentId];

                visualToggleEvent(
                    pathname,
                    _.join(
                        [categorySuperParent, categoryParent, category].filter(d => d != null).map(d => d.displayName),
                        " -> "
                    ),
                    tab.id as "graph" | "info" | "table"
                );
            };
        });
    }, [categories, pathname, tIdToCategory]);

    return (
        <>
            {categories?.map((category, index) => {
                const {
                    //tid,
                    faIcon,
                    theme,
                    displayName
                } = category;
                return (
                    <GraphTableInfoToggle
                        // key={tid}
                        key={index}
                        title={
                            <>
                                {faIcon != null && faIcon.toString().trim() !== "" && (
                                    <span
                                        className={`${faIcon ?? ""} icon`}
                                        style={{
                                            ...(theme != null && theme.toString().trim() !== ""
                                                ? { color: getColor(theme) }
                                                : {})
                                        }}
                                    ></span>
                                )}
                                {displayName != null && displayName.toString().trim() !== "" && (
                                    <div className="title">{displayName}</div>
                                )}
                            </>
                        }
                        graph={
                            category?.catGraphContent?.length > 0 ? (
                                <CategoryContent
                                    category={category}
                                    graphicElementIds={
                                        category?.catGraphContent
                                            ?.map(d => d.nid)
                                            ?.filter(d => d != null && d.toString().trim() !== "") ?? []
                                    }
                                />
                            ) : undefined
                        }
                        table={
                            category?.catTableContent?.length > 0 ? (
                                <CategoryContent
                                    category={category}
                                    graphicElementIds={
                                        category?.catTableContent
                                            ?.map(d => d.nid)
                                            ?.filter(d => d != null && d.toString().trim() !== "") ?? []
                                    }
                                />
                            ) : undefined
                        }
                        info={
                            category?.catInfoContent?.length > 0 ? (
                                <CategoryContent
                                    category={category}
                                    graphicElementIds={
                                        category?.catInfoContent
                                            ?.map(d => d.nid)
                                            ?.filter(d => d != null && d.toString().trim() !== "") ?? []
                                    }
                                />
                            ) : undefined
                        }
                        onTabActivated={categoriesTabActivated[index]}
                    />
                );
            })}
        </>
    );
};
